module.exports = __webpack_public_path__ + "img/landing-1-cs-CZ.cbb1907.png";